import { useTranslation } from 'react-i18next'

interface StatCardProps {
  value: string | number
  translationKey: string
  icon: React.ReactNode
  // Variante resserrée (page de recommandation). Sans elle, la carte garde
  // exactement sa taille d'origine pour les autres pages qui l'utilisent.
  compact?: boolean
}

export const StatCard = ({
  value,
  translationKey,
  icon,
  compact = false,
}: StatCardProps) => {
  const { t } = useTranslation()

  // Un compteur à zéro est une valeur valide mais sans enjeu : on l'estompe
  // pour que l'œil aille vers les cartes qui contiennent quelque chose. Les
  // valeurs textuelles (non numériques) gardent le style plein.
  const isZero = Number(value) === 0 && value !== ''

  return (
    <div
      className={`flex items-center rounded-3xl border border-gray-100 bg-white shadow-1 ${
        compact ? 'gap-3 p-3' : 'gap-4 p-5'
      }`}
    >
      <div
        className={`flex flex-none items-center justify-center rounded-xl bg-gradient-orange-fuschia text-white ${
          compact ? 'h-9 w-9' : 'h-11 w-11'
        }`}
      >
        {icon}
      </div>
      <div className="flex items-center gap-1.5">
        <div
          data-testid="stat-card-value"
          className={`font-space-grotesk text-2xl font-bold leading-none ${
            isZero
              ? 'text-gray-400'
              : 'bg-gradient-orange-fuschia bg-clip-text text-transparent'
          }`}
        >
          {value}
        </div>
        <p className="pl-2 text-black-900">{t(translationKey)}</p>
      </div>
    </div>
  )
}
